import Clients from "screens/Clients";

const clientRoutes = [
  {
    name: "Clients",
    path: '/clients',
    component: Clients,
    exact: true,
    featureKey: "CLIENTS.CLIENTS_READ"
  }
]

export default clientRoutes;

